import { useQueryClient } from "@tanstack/react-query";
import { CMS_PAGES_QUERY_KEY } from "@/features/shop/cms/hooks/useCmsPagesQuery";
import type { CmsPage } from "@/features/shop/cms/types/cms.types";

export const useCmsPages = () => {
  const queryClient = useQueryClient();

  const cmsPages = queryClient.getQueryData<CmsPage[]>(CMS_PAGES_QUERY_KEY);

  return { cmsPages };
};
